// Multilingual translations
export const LANGS = ["de", "fr", "it", "en"];

export const LANG_NAMES = {
  de: "Deutsch",
  fr: "Français",
  it: "Italiano",
  en: "English",
};

export const translations = {
  de: {
    nav: { home: "Home", book: "Buchen", massagen: "Massagen", klangschalen: "Klangschalen", ernaehrung: "Ernährung", vouchers: "Gutscheine", about: "Über mich", standort: "Standort", admin: "Admin" },
    hero: {
      eyebrow: "Ayurveda für Frauen · Sarmenstorf & Rupperswil",
      title: "Die Weisheit des langen Lebens.",
      subtitle: "Ayurvedische Massagen, Klangschalen und Ernährungsberatung in einer ruhigen Praxis im Seetal und in Rupperswil. Für Frauen, die in ihre natürliche Balance zurückfinden möchten.",
      cta_book: "Jetzt Termin buchen",
      cta_services: "Behandlungen entdecken",
    },
    intro: {
      title: "Das Wissen vom gesunden Leben",
      body: "Ayurveda ist die über 5000 Jahre alte, schriftlich festgehaltene Heilkunde Indiens, die sich hauptsächlich mit der Aufrechterhaltung der Harmonie von Körper, Geist und Seele beschäftigt. Ayurveda bedeutet «das Wissen vom gesunden Leben». Ayurveda versucht den Menschen in einem ganzheitlichen Sinn zu heilen.",
      info: "Massagen für Frauen! Die Massagen können direkt vor Ort bar oder via Twint bezahlt werden. Natürlich ist auch die Einlösung eines gültigen Gutscheins möglich. Informiere uns mindestens 24 Stunden vor Termin über deine Verschiebung oder Absage – ansonsten erlauben wir uns, den Termin voll zu verrechnen. (noch) nicht Krankenkassen anerkannt.",
    },
    services: {
      title: "Meine ayurvedischen Angebote",
      subtitle: "Eine sorgfältige Auswahl traditioneller ayurvedischer Massagen.",
      duration: "Dauer",
      price: "Preis",
      minutes: "Min.",
      book: "Jetzt buchen",
      learn_more: "Mehr erfahren",
      indications: "Indikationen & mögliche Wirkung",
      effects: "Wirkungen",
      contraindications: "Kontraindikationen",
      includes: "Im Termin enthalten",
    },
    klangschalen: {
      title: "Klangschalen",
      subtitle: "Unterstützt die Entspannung",
      lead: "Die Massagen werden zu Beginn und zum Abschluss mit der Klangschale unterstützt. Dabei sorgen die Schallwellen und die durch den Anschlag entstehenden Töne für eine beruhigende Wirkung auf den Geist.",
      quote: "Die Musik beginnt da, wo Worte enden.",
      origin: "Die Klangschalen kommen aus Indien, Nepal und Tibet.",
      effect_title: "So wirken die Klangschalen",
      effect_body: "Aus jahrzehntelanger Praxiserfahrung sowie verschiedenen Forschungsergebnissen lassen sich folgende Wirkungsmerkmale zusammenfassen: wirkt ganzheitlich auf Körper, Seele und Geist, bewirkt tiefe Entspannung, stärkt das Urvertrauen.",
      massage_title: "Wirkung der Klangschalen bei der Massage",
      massage_body: "Dieser Effekt soll letztlich wie eine innere Massage der Körperzellen wirken und körperliche Verspannungen sowie seelische Blockaden lösen. Dabei schwingen die Zellen zunächst mit der Frequenz der Klangschale und finden nach kurzer Zeit zu ihrem eigenen Rhythmus zurück.",
      benefits: ["Tiefe Entspannung von Körper, Seele und Geist", "Stärkt das Urvertrauen", "Löst körperliche Verspannungen", "Löst seelische Blockaden", "Verlangsamt die Atemfrequenz", "Wirkt wie eine innere Zellmassage"],
    },
    ernaehrung: {
      title: "Ayurvedische Ernährung",
      subtitle: "Nahrung als Medizin",
      lead: "Im Ayurveda gilt die Ernährung als wichtigste Säule der Gesundheit. Was wir essen, prägt unseren Körper, unseren Geist und unsere Energie. Eine auf den individuellen Konstitutionstyp (Dosha) abgestimmte Ernährung bringt den Körper zurück in seine natürliche Balance.",
      pillars_title: "Drei Doshas, drei Wege",
      pillars: [
        { name: "Vata", body: "Bewegung & Wind. Verlangt nach warmen, geerdeten, nährenden Speisen." },
        { name: "Pitta", body: "Feuer & Transformation. Profitiert von kühlenden, beruhigenden Lebensmitteln." },
        { name: "Kapha", body: "Erde & Wasser. Braucht leichte, trockene, anregende Speisen." },
      ],
      consult_title: "Ernährungsberatung",
      consult_body: "Ich begleite dich gerne dabei, deine persönliche Konstitution zu erkennen und deinen Speiseplan auf deine Bedürfnisse, deine Lebensphase und dein Ziel auszurichten. Eine Beratung dauert ca. 60 Minuten und kann vor Ort oder online stattfinden.",
      consult_cta: "Beratung anfragen",
    },
    vouchers: {
      title: "Geschenkgutscheine",
      subtitle: "Ein Geschenk, das wirklich gut tut",
      lead: "Schenke deinen Liebsten eine Auszeit. Unsere Geschenkgutscheine sind die perfekte Aufmerksamkeit zum Geburtstag, Muttertag oder einfach so. Wähle einen Betrag oder eine bestimmte Behandlung – wir kümmern uns um den Rest.",
      choose_amount: "Betrag wählen",
      custom_amount: "Eigener Betrag (CHF)",
      buyer: "Käuferin",
      recipient: "Empfängerin (optional)",
      buyer_name: "Dein Name",
      buyer_email: "Deine E-Mail",
      buyer_phone: "Telefon (optional)",
      recipient_name: "Name der Empfängerin",
      message: "Persönliche Nachricht (optional)",
      submit: "Gutschein anfragen",
      success: "Vielen Dank! Wir melden uns in Kürze mit Zahlungsangaben und stellen den Gutschein dann zu.",
      hint: "Die Bezahlung erfolgt per Rechnung oder Twint. Nach Zahlungseingang stellen wir den Gutschein per Post oder digital zu.",
    },
    about: {
      title: "Über mich",
      lead: "Menschen interessieren mich – nicht nur als Gesellschaft, sondern jeder Mensch in seiner Einzigartigkeit. Seine Geschichte, die Gegenwart, die persönlichen Bedürfnisse, sein Wohlbefinden und die individuelle Gesundheit.",
      name: "Regula Müller",
      body: "«Liebe» auf Sanskrit ist die Kraft, durch die meine Therapien und Beratungen dein körperliches und seelisches Wohlbefinden stärken. Mit Herz, Wissen, Erfahrung und Intuition leite ich dich dazu an, deine harmonische Balance, körperliche Vitalität und emotionale Ausgeglichenheit (wieder) zu finden.",
      body2: "Ich stimme die Behandlung ganz auf dich und deine individuellen Bedürfnisse ab. Dabei können therapeutische Behandlungen ebenso zur Anwendung kommen wie die Optimierung von Ernährung und Lebensstil.",
      qual_title: "Ausbildung",
      qual_1: "Ayurveda Massage-Praktikerin – Rosenberg Europäische Akademie für Ayurveda / Heilpraktikerschule Luzern",
      qual_2: "Ayurveda Ernährungs- und Gesundheitsberaterin",
    },
    booking: {
      title: "Termin anfragen",
      subtitle: "Die Anfrage wird per E-Mail bestätigt. Die definitive Bestätigung erfolgt telefonisch.",
      step1: "1. Behandlung", step2: "2. Datum", step3: "3. Uhrzeit", step4: "4. Deine Angaben",
      choose_service: "Wähle eine Behandlung", choose_date: "Wähle ein Datum", choose_time: "Wähle eine Uhrzeit",
      no_slots: "Keine freien Termine an diesem Tag.",
      first_name: "Vorname", last_name: "Nachname", email: "E-Mail", phone: "Telefon", notes: "Mitteilung (optional)",
      birthdate: "Geburtsdatum", address: "Adresse (Strasse / Nr.)", postal_code: "PLZ", city: "Ort",
      back: "Zurück", next: "Weiter", submit: "Anfrage senden",
      success_title: "Anfrage erhalten",
      success_text: "Vielen Dank! Du erhältst gleich eine Bestätigung per E-Mail. Die definitive Terminbestätigung erfolgt innerhalb von maximal 48 Stunden telefonisch.",
      new_booking: "Neue Anfrage", summary: "Zusammenfassung",
      join_waitlist: "Auf Warteliste setzen",
      waitlist_title: "Warteliste",
      waitlist_subtitle: "Kein Termin frei?",
      waitlist_intro: "Wir setzen dich auf die Warteliste und benachrichtigen dich automatisch per E-Mail, sobald ein Termin frei wird.",
      waitlist_submit: "Auf Warteliste eintragen",
      waitlist_success: "Wir haben dich auf die Warteliste gesetzt – du erhältst eine Bestätigung per E-Mail.",
    },
    standort: {
      title: "Standort",
      subtitle: "Wir freuen uns auf deinen Besuch.",
      address_label: "Postanschrift",
      hours_label: "Öffnungszeiten",
      contact_label: "Kontakt",
      booking_email: "Buchung",
      general_email: "Allgemeine Anfrage",
      phone_label: "Telefon",
      send_msg_title: "Nachricht senden",
      send_msg_body: "Schreib mir deine Wünsche oder Ziele – ich melde mich bei dir.",
      name: "Name", email: "E-Mail", phone: "Telefon (optional)", message: "Nachricht", send: "Nachricht senden",
      sent: "Danke! Deine Nachricht ist bei mir angekommen.",
    },
    days: { mon: "Montag", tue: "Dienstag", wed: "Mittwoch", thu: "Donnerstag", fri: "Freitag", sat: "Samstag", sun: "Sonntag" },
    days_short: { mon: "Mo", tue: "Di", wed: "Mi", thu: "Do", fri: "Fr", sat: "Sa", sun: "So" },
    admin: {
      login: "Admin Login", email: "E-Mail", password: "Passwort", sign_in: "Anmelden", logout: "Abmelden",
      dashboard: "Dashboard", bookings: "Buchungen", services: "Behandlungen", availability: "Verfügbarkeit", customers: "Kundinnen", settings: "Einstellungen", vouchers: "Gutscheine", messages: "Nachrichten", waitlist: "Warteliste", hero_images: "Startseiten-Bilder", finances: "Finanzen",
      pending: "Offen", confirmed: "Bestätigt", cancelled: "Storniert",
      confirm: "Bestätigen", cancel: "Stornieren", delete: "Löschen", edit: "Bearbeiten", add_new: "Neu hinzufügen", save: "Speichern",
      status: "Status", date: "Datum", time: "Uhrzeit", service: "Behandlung", customer: "Kundin", contact: "Kontakt", total: "Total",
      filter: "Filter", all: "Alle",
      slot_step: "Slot-Intervall (Minuten)", blocked_dates: "Geblockte Tage (YYYY-MM-DD, kommagetrennt)", working_hours: "Arbeitszeiten",
    },
    footer: { tagline: "Massage für Frauen", rights: "Alle Rechte vorbehalten.", impressum: "Impressum" },
    common: { closed: "Geschlossen", open: "Offen" },
  },
  fr: {
    nav: { home: "Accueil", book: "Réserver", massagen: "Massages", klangschalen: "Bols chantants", ernaehrung: "Nutrition", vouchers: "Bons cadeaux", about: "À propos", standort: "Lieu", admin: "Admin" },
    hero: {
      eyebrow: "Ayurveda pour femmes · Sarmenstorf & Rupperswil",
      title: "La sagesse de la longue vie.",
      subtitle: "Massages ayurvédiques, bols chantants et conseils en nutrition dans un cabinet paisible au cœur du Seetal et à Rupperswil.",
      cta_book: "Prendre rendez-vous", cta_services: "Découvrir les soins",
    },
    intro: {
      title: "Le savoir d'une vie saine",
      body: "L'Ayurveda est l'art de guérir indien vieux de plus de 5000 ans. Ayurveda signifie « le savoir d'une vie saine ».",
      info: "Massages pour femmes uniquement. Paiement sur place en espèces ou Twint. Les bons cadeaux sont acceptés. Annulation au moins 24h à l'avance.",
    },
    services: { title: "Mes soins ayurvédiques", subtitle: "Une sélection soignée de massages ayurvédiques traditionnels.", duration: "Durée", price: "Prix", minutes: "min", book: "Réserver", learn_more: "En savoir plus", indications: "Indications & effets", effects: "Effets", contraindications: "Contre-indications", includes: "Inclus dans le rendez-vous" },
    klangschalen: {
      title: "Bols chantants", subtitle: "Soutiennent la relaxation",
      lead: "Les massages débutent et se terminent avec un bol chantant. Les ondes sonores apaisent l'esprit.",
      quote: "La musique commence là où les mots s'arrêtent.",
      origin: "Les bols chantants viennent d'Inde, du Népal et du Tibet.",
      effect_title: "L'effet des bols chantants",
      effect_body: "Une action holistique sur le corps, l'âme et l'esprit. Une relaxation profonde, renforce la confiance.",
      massage_title: "Effet pendant le massage",
      massage_body: "Un massage intérieur des cellules : libère les tensions corporelles et les blocages émotionnels.",
      benefits: ["Détente profonde du corps et de l'esprit", "Renforce la confiance", "Libère les tensions", "Libère les blocages émotionnels", "Ralentit la respiration", "Massage intérieur des cellules"],
    },
    ernaehrung: {
      title: "Nutrition ayurvédique", subtitle: "L'alimentation comme médecine",
      lead: "Dans l'Ayurveda, l'alimentation est le pilier de la santé. Une alimentation adaptée à votre constitution (Dosha) ramène le corps à son équilibre naturel.",
      pillars_title: "Trois Doshas, trois chemins",
      pillars: [
        { name: "Vata", body: "Mouvement & vent. Demande des plats chauds, ancrés et nourrissants." },
        { name: "Pitta", body: "Feu & transformation. Bénéficie d'aliments rafraîchissants et apaisants." },
        { name: "Kapha", body: "Terre & eau. A besoin d'aliments légers, secs et stimulants." },
      ],
      consult_title: "Consultation",
      consult_body: "Je vous accompagne pour identifier votre constitution et adapter votre alimentation. Consultation d'environ 60 minutes, sur place ou en ligne.",
      consult_cta: "Demander un rendez-vous",
    },
    vouchers: {
      title: "Bons cadeaux", subtitle: "Un cadeau qui fait vraiment du bien",
      lead: "Offrez à vos proches une pause de bien-être. Parfait pour un anniversaire, la fête des mères ou tout simplement par attention.",
      choose_amount: "Choisissez un montant", custom_amount: "Montant personnalisé (CHF)",
      buyer: "Acheteuse", recipient: "Destinataire (optionnel)",
      buyer_name: "Votre nom", buyer_email: "Votre e-mail", buyer_phone: "Téléphone (optionnel)",
      recipient_name: "Nom de la destinataire", message: "Message personnel (optionnel)",
      submit: "Demander le bon", success: "Merci ! Nous vous contacterons sous peu.", hint: "Paiement par facture ou Twint. Le bon est envoyé après réception du paiement.",
    },
    about: {
      title: "À propos de moi",
      lead: "Les gens m'intéressent – non seulement en tant que société, mais chaque personne dans son unicité.",
      name: "Regula Müller",
      body: "«Amour» en sanskrit est la force par laquelle mes thérapies et conseils renforcent votre bien-être physique et émotionnel.",
      body2: "J'adapte le traitement entièrement à vos besoins individuels.",
      qual_title: "Formation",
      qual_1: "Praticienne en massage ayurvédique – Académie européenne d'ayurveda Rosenberg / École de naturopathie Lucerne",
      qual_2: "Conseillère en nutrition et santé ayurvédique",
    },
    booking: {
      title: "Demande de rendez-vous",
      subtitle: "La demande est confirmée par e-mail. La confirmation définitive se fait par téléphone.",
      step1: "1. Soin", step2: "2. Date", step3: "3. Heure", step4: "4. Vos coordonnées",
      choose_service: "Choisissez un soin", choose_date: "Choisissez une date", choose_time: "Choisissez une heure",
      no_slots: "Aucun créneau disponible ce jour.",
      first_name: "Prénom", last_name: "Nom", email: "E-mail", phone: "Téléphone", notes: "Message (optionnel)",
      birthdate: "Date de naissance", address: "Adresse (rue / n°)", postal_code: "NPA", city: "Localité",
      back: "Retour", next: "Suivant", submit: "Envoyer la demande",
      success_title: "Demande reçue",
      success_text: "Merci ! Vous recevrez une confirmation par e-mail. La confirmation définitive se fait par téléphone dans un délai maximal de 48 heures.",
      new_booking: "Nouvelle demande", summary: "Résumé",
      join_waitlist: "Liste d'attente",
      waitlist_title: "Liste d'attente",
      waitlist_subtitle: "Pas de créneau ?",
      waitlist_intro: "Nous vous ajoutons à la liste d'attente et vous prévenons par e-mail dès qu'un créneau se libère.",
      waitlist_submit: "M'inscrire",
      waitlist_success: "Inscription confirmée – un e-mail vous a été envoyé.",
    },
    standort: {
      title: "Lieu", subtitle: "Au plaisir de vous accueillir.",
      address_label: "Adresse", hours_label: "Horaires", contact_label: "Contact",
      booking_email: "Réservation", general_email: "Demande générale", phone_label: "Téléphone",
      send_msg_title: "Envoyer un message", send_msg_body: "Écrivez-moi vos souhaits ou objectifs – je vous répondrai.",
      name: "Nom", email: "E-mail", phone: "Téléphone (optionnel)", message: "Message", send: "Envoyer le message",
      sent: "Merci ! Votre message m'est bien parvenu.",
    },
    days: { mon: "Lundi", tue: "Mardi", wed: "Mercredi", thu: "Jeudi", fri: "Vendredi", sat: "Samedi", sun: "Dimanche" },
    days_short: { mon: "Lu", tue: "Ma", wed: "Me", thu: "Je", fri: "Ve", sat: "Sa", sun: "Di" },
    admin: {
      login: "Connexion admin", email: "E-mail", password: "Mot de passe", sign_in: "Se connecter", logout: "Déconnexion",
      dashboard: "Tableau de bord", bookings: "Réservations", services: "Soins", availability: "Disponibilité", customers: "Clientes", settings: "Paramètres", vouchers: "Bons", messages: "Messages", waitlist: "Liste d'attente", hero_images: "Images d'accueil", finances: "Finances",
      pending: "En attente", confirmed: "Confirmé", cancelled: "Annulé",
      confirm: "Confirmer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier", add_new: "Ajouter", save: "Enregistrer",
      status: "Statut", date: "Date", time: "Heure", service: "Soin", customer: "Cliente", contact: "Contact", total: "Total",
      filter: "Filtre", all: "Tous",
      slot_step: "Intervalle (minutes)", blocked_dates: "Jours bloqués (YYYY-MM-DD, séparés par virgules)", working_hours: "Horaires de travail",
    },
    footer: { tagline: "Massage pour femmes", rights: "Tous droits réservés.", impressum: "Mentions légales" },
    common: { closed: "Fermé", open: "Ouvert" },
  },
  it: {
    nav: { home: "Home", book: "Prenota", massagen: "Massaggi", klangschalen: "Campane tibetane", ernaehrung: "Nutrizione", vouchers: "Buoni regalo", about: "Chi sono", standort: "Sede", admin: "Admin" },
    hero: {
      eyebrow: "Ayurveda per donne · Sarmenstorf & Rupperswil",
      title: "La saggezza della lunga vita.",
      subtitle: "Massaggi ayurvedici, campane tibetane e consulenza nutrizionale in uno studio tranquillo nel Seetal e a Rupperswil.",
      cta_book: "Prenota un appuntamento", cta_services: "Scopri i trattamenti",
    },
    intro: {
      title: "Il sapere della vita sana",
      body: "L'Ayurveda è l'antica arte indiana della guarigione vecchia di oltre 5000 anni. Ayurveda significa «sapere della vita sana».",
      info: "Massaggi solo per donne. Pagamento in contanti o Twint. I buoni regalo sono accettati. Disdetta almeno 24h prima.",
    },
    services: { title: "I miei trattamenti ayurvedici", subtitle: "Una selezione curata di massaggi tradizionali.", duration: "Durata", price: "Prezzo", minutes: "min", book: "Prenota", learn_more: "Scopri di più", indications: "Indicazioni & effetti", effects: "Effetti", contraindications: "Controindicazioni", includes: "Incluso nell'appuntamento" },
    klangschalen: {
      title: "Campane tibetane", subtitle: "Sostengono il rilassamento",
      lead: "I massaggi iniziano e si concludono con la campana tibetana. Le onde sonore calmano la mente.",
      quote: "La musica inizia dove finiscono le parole.",
      origin: "Le campane vengono da India, Nepal e Tibet.",
      effect_title: "L'effetto delle campane",
      effect_body: "Azione olistica su corpo, anima e spirito. Profondo rilassamento, rafforza la fiducia di base.",
      massage_title: "Effetto durante il massaggio",
      massage_body: "Un massaggio interiore delle cellule: scioglie tensioni fisiche e blocchi emotivi.",
      benefits: ["Profondo rilassamento", "Rafforza la fiducia", "Scioglie le tensioni", "Scioglie i blocchi emotivi", "Rallenta il respiro", "Massaggio cellulare interiore"],
    },
    ernaehrung: {
      title: "Nutrizione ayurvedica", subtitle: "Il cibo come medicina",
      lead: "Nell'Ayurveda l'alimentazione è il pilastro più importante della salute. Un'alimentazione adeguata alla tua costituzione (Dosha) riporta il corpo al suo equilibrio naturale.",
      pillars_title: "Tre Dosha, tre vie",
      pillars: [
        { name: "Vata", body: "Movimento & vento. Richiede cibi caldi, radicanti, nutrienti." },
        { name: "Pitta", body: "Fuoco & trasformazione. Beneficia di cibi rinfrescanti e calmanti." },
        { name: "Kapha", body: "Terra & acqua. Necessita cibi leggeri, secchi, stimolanti." },
      ],
      consult_title: "Consulenza",
      consult_body: "Ti accompagno nel riconoscere la tua costituzione e adattare la tua alimentazione. Consulenza di circa 60 minuti, in studio o online.",
      consult_cta: "Richiedi consulenza",
    },
    vouchers: {
      title: "Buoni regalo", subtitle: "Un regalo che fa davvero bene",
      lead: "Regala una pausa di benessere. Perfetto per compleanni, festa della mamma o solo per affetto.",
      choose_amount: "Scegli l'importo", custom_amount: "Importo personalizzato (CHF)",
      buyer: "Acquirente", recipient: "Destinataria (opzionale)",
      buyer_name: "Il tuo nome", buyer_email: "La tua e-mail", buyer_phone: "Telefono (opzionale)",
      recipient_name: "Nome della destinataria", message: "Messaggio personale (opzionale)",
      submit: "Richiedi buono", success: "Grazie! Ti contatteremo a breve.", hint: "Pagamento tramite fattura o Twint. Il buono viene inviato dopo il pagamento.",
    },
    about: {
      title: "Chi sono",
      lead: "Le persone mi interessano – non solo come società, ma ogni persona nella sua unicità.",
      name: "Regula Müller",
      body: "«Amore» in sanscrito è la forza con cui le mie terapie e consulenze rafforzano il tuo benessere fisico ed emotivo.",
      body2: "Adatto completamente il trattamento alle tue esigenze individuali.",
      qual_title: "Formazione",
      qual_1: "Operatrice in massaggio ayurvedico – Accademia europea Ayurveda Rosenberg / Scuola di naturopatia Lucerna",
      qual_2: "Consulente in nutrizione e salute ayurvedica",
    },
    booking: {
      title: "Richiesta di appuntamento",
      subtitle: "La richiesta viene confermata via e-mail. La conferma definitiva avviene per telefono.",
      step1: "1. Trattamento", step2: "2. Data", step3: "3. Ora", step4: "4. I tuoi dati",
      choose_service: "Scegli un trattamento", choose_date: "Scegli una data", choose_time: "Scegli un'ora",
      no_slots: "Nessuno slot disponibile in questo giorno.",
      first_name: "Nome", last_name: "Cognome", email: "E-mail", phone: "Telefono", notes: "Messaggio (opzionale)",
      birthdate: "Data di nascita", address: "Indirizzo (via / n°)", postal_code: "CAP", city: "Località",
      back: "Indietro", next: "Avanti", submit: "Invia richiesta",
      success_title: "Richiesta ricevuta",
      success_text: "Grazie! Riceverai una conferma via e-mail. La conferma definitiva avviene per telefono entro massimo 48 ore.",
      new_booking: "Nuova richiesta", summary: "Riepilogo",
      join_waitlist: "Lista d'attesa",
      waitlist_title: "Lista d'attesa",
      waitlist_subtitle: "Nessun posto?",
      waitlist_intro: "Ti aggiungiamo alla lista d'attesa e ti avvisiamo via e-mail appena si libera un posto.",
      waitlist_submit: "Iscriviti",
      waitlist_success: "Iscrizione confermata – riceverai una e-mail.",
    },
    standort: {
      title: "Sede", subtitle: "Ti aspettiamo con piacere.",
      address_label: "Indirizzo", hours_label: "Orari", contact_label: "Contatto",
      booking_email: "Prenotazione", general_email: "Informazioni generali", phone_label: "Telefono",
      send_msg_title: "Invia un messaggio", send_msg_body: "Scrivimi i tuoi desideri o obiettivi – ti risponderò.",
      name: "Nome", email: "E-mail", phone: "Telefono (opzionale)", message: "Messaggio", send: "Invia messaggio",
      sent: "Grazie! Il tuo messaggio è arrivato.",
    },
    days: { mon: "Lunedì", tue: "Martedì", wed: "Mercoledì", thu: "Giovedì", fri: "Venerdì", sat: "Sabato", sun: "Domenica" },
    days_short: { mon: "Lu", tue: "Ma", wed: "Me", thu: "Gi", fri: "Ve", sat: "Sa", sun: "Do" },
    admin: {
      login: "Login admin", email: "E-mail", password: "Password", sign_in: "Accedi", logout: "Esci",
      dashboard: "Pannello", bookings: "Prenotazioni", services: "Trattamenti", availability: "Disponibilità", customers: "Clienti", settings: "Impostazioni", vouchers: "Buoni", messages: "Messaggi", waitlist: "Lista d'attesa", hero_images: "Immagini home", finances: "Finanze",
      pending: "In attesa", confirmed: "Confermata", cancelled: "Annullata",
      confirm: "Conferma", cancel: "Annulla", delete: "Elimina", edit: "Modifica", add_new: "Aggiungi", save: "Salva",
      status: "Stato", date: "Data", time: "Ora", service: "Trattamento", customer: "Cliente", contact: "Contatto", total: "Totale",
      filter: "Filtro", all: "Tutti",
      slot_step: "Intervallo (minuti)", blocked_dates: "Giorni bloccati (YYYY-MM-DD, separati da virgole)", working_hours: "Orari di lavoro",
    },
    footer: { tagline: "Massaggi per donne", rights: "Tutti i diritti riservati.", impressum: "Note legali" },
    common: { closed: "Chiuso", open: "Aperto" },
  },
  en: {
    nav: { home: "Home", book: "Book", massagen: "Massages", klangschalen: "Singing Bowls", ernaehrung: "Nutrition", vouchers: "Gift Vouchers", about: "About", standort: "Location", admin: "Admin" },
    hero: {
      eyebrow: "Ayurveda for women · Sarmenstorf & Rupperswil",
      title: "The wisdom of a long life.",
      subtitle: "Ayurvedic massage, singing bowls and nutrition consultation in a quiet practice in the Seetal valley and in Rupperswil.",
      cta_book: "Book your treatment", cta_services: "Explore treatments",
    },
    intro: {
      title: "The knowledge of healthy life",
      body: "Ayurveda is the over 5000-year-old written healing art of India. Ayurveda means «the knowledge of healthy life».",
      info: "Massages for women only. Payment on site by cash or Twint. Vouchers accepted. Please cancel at least 24 hours in advance.",
    },
    services: { title: "My Ayurvedic treatments", subtitle: "A carefully curated selection of traditional massages.", duration: "Duration", price: "Price", minutes: "min", book: "Book now", learn_more: "Learn more", indications: "Indications & effects", effects: "Effects", contraindications: "Contraindications", includes: "Included in appointment" },
    klangschalen: {
      title: "Singing Bowls", subtitle: "Supporting relaxation",
      lead: "Massages begin and end with a singing bowl. The sound waves bring deep calm to the mind.",
      quote: "Music begins where words end.",
      origin: "The singing bowls come from India, Nepal and Tibet.",
      effect_title: "How singing bowls work",
      effect_body: "Holistic effect on body, soul and mind. Deep relaxation, strengthens trust.",
      massage_title: "Effect during massage",
      massage_body: "An inner massage of the cells: releases physical tension and emotional blocks.",
      benefits: ["Deep relaxation", "Strengthens trust", "Releases tension", "Releases emotional blocks", "Slows breathing", "Inner cellular massage"],
    },
    ernaehrung: {
      title: "Ayurvedic Nutrition", subtitle: "Food as medicine",
      lead: "In Ayurveda, nutrition is the most important pillar of health. A diet tailored to your constitution (Dosha) brings the body back into its natural balance.",
      pillars_title: "Three Doshas, three ways",
      pillars: [
        { name: "Vata", body: "Movement & wind. Calls for warm, grounding, nourishing foods." },
        { name: "Pitta", body: "Fire & transformation. Benefits from cooling, calming foods." },
        { name: "Kapha", body: "Earth & water. Needs light, dry, stimulating foods." },
      ],
      consult_title: "Consultation",
      consult_body: "I accompany you in discovering your personal constitution and aligning your nutrition. A consultation lasts about 60 minutes, on site or online.",
      consult_cta: "Request consultation",
    },
    vouchers: {
      title: "Gift Vouchers", subtitle: "A truly nourishing gift",
      lead: "Give your loved ones a moment of well-being. Perfect for birthdays, Mother's Day or just because.",
      choose_amount: "Choose an amount", custom_amount: "Custom amount (CHF)",
      buyer: "Buyer", recipient: "Recipient (optional)",
      buyer_name: "Your name", buyer_email: "Your email", buyer_phone: "Phone (optional)",
      recipient_name: "Recipient's name", message: "Personal message (optional)",
      submit: "Request voucher", success: "Thank you! We'll be in touch shortly.", hint: "Payment by invoice or Twint. The voucher is sent after payment is received.",
    },
    about: {
      title: "About me",
      lead: "People interest me – not only as a society, but each person in their uniqueness.",
      name: "Regula Müller",
      body: "“Love” in Sanskrit is the force through which my therapies and consultations strengthen your physical and emotional well-being.",
      body2: "I tailor each treatment entirely to you and your individual needs.",
      qual_title: "Training",
      qual_1: "Ayurvedic massage practitioner – Rosenberg European Academy for Ayurveda / Lucerne School of Naturopathy",
      qual_2: "Ayurvedic nutrition and health consultant",
    },
    booking: {
      title: "Book an appointment",
      subtitle: "Your request will be confirmed by email. Final confirmation happens by phone.",
      step1: "1. Treatment", step2: "2. Date", step3: "3. Time", step4: "4. Your details",
      choose_service: "Choose a treatment", choose_date: "Choose a date", choose_time: "Choose a time",
      no_slots: "No available slots on this day.",
      first_name: "First name", last_name: "Last name", email: "Email", phone: "Phone", notes: "Message (optional)",
      birthdate: "Date of birth", address: "Address (street / no.)", postal_code: "ZIP", city: "City",
      back: "Back", next: "Next", submit: "Send request",
      success_title: "Request received",
      success_text: "Thank you! You will receive an email confirmation. Final confirmation happens by phone within a maximum of 48 hours.",
      new_booking: "New request", summary: "Summary",
      join_waitlist: "Join waiting list",
      waitlist_title: "Waiting list",
      waitlist_subtitle: "No slot available?",
      waitlist_intro: "We'll add you to the waiting list and notify you by email as soon as a slot opens up.",
      waitlist_submit: "Join the list",
      waitlist_success: "You're on the waiting list – check your email for confirmation.",
    },
    standort: {
      title: "Location", subtitle: "We look forward to welcoming you.",
      address_label: "Address", hours_label: "Hours", contact_label: "Contact",
      booking_email: "Booking", general_email: "General inquiry", phone_label: "Phone",
      send_msg_title: "Send a message", send_msg_body: "Tell me your wishes or goals – I'll get back to you.",
      name: "Name", email: "Email", phone: "Phone (optional)", message: "Message", send: "Send message",
      sent: "Thank you! Your message reached me.",
    },
    days: { mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday", fri: "Friday", sat: "Saturday", sun: "Sunday" },
    days_short: { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" },
    admin: {
      login: "Admin login", email: "Email", password: "Password", sign_in: "Sign in", logout: "Sign out",
      dashboard: "Dashboard", bookings: "Bookings", services: "Treatments", availability: "Availability", customers: "Customers", settings: "Settings", vouchers: "Vouchers", messages: "Messages", waitlist: "Waiting list", hero_images: "Home images", finances: "Finances",
      pending: "Pending", confirmed: "Confirmed", cancelled: "Cancelled",
      confirm: "Confirm", cancel: "Cancel", delete: "Delete", edit: "Edit", add_new: "Add new", save: "Save",
      status: "Status", date: "Date", time: "Time", service: "Treatment", customer: "Customer", contact: "Contact", total: "Total",
      filter: "Filter", all: "All",
      slot_step: "Slot interval (minutes)", blocked_dates: "Blocked dates (YYYY-MM-DD, comma separated)", working_hours: "Working hours",
    },
    footer: { tagline: "Massage for women", rights: "All rights reserved.", impressum: "Imprint" },
    common: { closed: "Closed", open: "Open" },
  },
};

export function t(lang, path) {
  const parts = path.split(".");
  let cur = translations[lang] || translations.de;
  for (const p of parts) {
    if (cur && cur[p] !== undefined) cur = cur[p];
    else return path;
  }
  return cur;
}

export function pickMulti(obj, lang) {
  if (!obj) return "";
  return obj[lang] || obj.de || obj.en || "";
}
